import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Quraan from "./pages/Quraan";
import Riwayat from "./pages/Riwayat";
import RiwayaReciters from "./pages/RiwayaReciters";
import DuaList from "./pages/DuaList";
import Dua from "./pages/Dua";
import TafsirList from "./pages/TafsirList";
import Tafsir from "./pages/Tafsir";
import TaraweehList from "./pages/TaraweehList";
import Taraweeh from "./pages/Taraweeh";
import Contact from "./pages/Contact";
import Sidebar from "./components/layout/Sidebar";
import Player from "./components/Player/Player";
import Footer from "./components/layout/Footer";
import "./App.css";

function App() {
  const [queue, setQueue] = useState(
    () => JSON.parse(localStorage.getItem("queueList")) || [],
  );
  const [current, setCurrent] = useState(
    () => parseInt(localStorage.getItem("player_current"), 10) || 0,
  );
  const [playing, setPlaying] = useState(
    () => JSON.parse(localStorage.getItem("player_playing")) || false,
  );
  const [liked, setLiked] = useState(
    () => JSON.parse(localStorage.getItem("likedAudioList")) || [],
  );

  return (
    <Router>
      <div className="app-layout">
        {/* LEFT MENU */}
        <Sidebar />

        {/* MAIN CONTENT */}
        <main className="main-content">
          <Routes>
            <Route
              path="/"
              element={
                <Quraan
                  queue={queue}
                  setQueue={setQueue}
                  setCurrent={setCurrent}
                  setPlaying={setPlaying}
                  liked={liked}
                  setLiked={setLiked}
                />
              }
            />

            {/* ✅ RECITERS BY SLUG */}
            <Route
              path="/reciter/:reciterSlug"
              element={
                <Quraan
                  queue={queue}
                  setQueue={setQueue}
                  setCurrent={setCurrent}
                  setPlaying={setPlaying}
                  liked={liked}
                  setLiked={setLiked}
                />
              }
            />

            {/* ✅ narration BY RECITER SLUG */}
            <Route
              path="/narration/:reciterSlug/:narrationSlug"
              element={
                <Quraan
                  queue={queue}
                  setQueue={setQueue}
                  setCurrent={setCurrent}
                  setPlaying={setPlaying}
                  liked={liked}
                  setLiked={setLiked}
                />
              }
            />

            {/* Riwaayat CATEGORIES */}
            <Route path="/narrations" element={<Riwayat />} />

            {/* Riwaayat Reciters */}
            <Route
              path="/narration/:categorySlug"
              element={<RiwayaReciters />}
            />

            {/* Duaa LIst */}
            <Route path="/dua" element={<DuaList />} />

            {/* Dua */}
            <Route
              path="/dua/:duaaSlug"
              element={
                <Dua
                  queue={queue}
                  setQueue={setQueue}
                  setCurrent={setCurrent}
                  setPlaying={setPlaying}
                  liked={liked}
                  setLiked={setLiked}
                />
              }
            />

            {/* Tafsir LIst */}
            <Route path="/tafsir" element={<TafsirList />} />

            {/* Tafsir */}
            <Route
              path="/tafsir/:tafsirSlug"
              element={
                <Tafsir
                  queue={queue}
                  setQueue={setQueue}
                  setCurrent={setCurrent}
                  setPlaying={setPlaying}
                  liked={liked}
                  setLiked={setLiked}
                />
              }
            />

            {/* Taraweeh LIst */}
            <Route path="/taraweeh" element={<TaraweehList />} />

            {/* Taraweeh */}
            <Route
              path="/taraweeh/:taraweehSlug"
              element={
                <Taraweeh
                  queue={queue}
                  setQueue={setQueue}
                  setCurrent={setCurrent}
                  setPlaying={setPlaying}
                  liked={liked}
                  setLiked={setLiked}
                />
              }
            />

            <Route path="/contact" element={<Contact />} />
          </Routes>

          <Footer />
        </main>

        <Player
          queue={queue}
          setQueue={setQueue}
          current={current}
          setCurrent={setCurrent}
          playing={playing}
          setPlaying={setPlaying}
          liked={liked}
          setLiked={setLiked}
        />
      </div>
    </Router>
  );
}

export default App;
